import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'
import { sortByKey } from 'util/arrays/sorting'
import { sortByName } from 'util/arrays'
import { selectFolders } from './folders'
import selectBase from './selectBase'

export const selectGroupsById = createSelector(
  selectBase,
  base => base.groupsById
)

export const selectGroups = createSelector(selectGroupsById, groupsById =>
  Object.values(groupsById)
)

export const selectGroupsSortedByName = createSelector(selectGroups, groups => {
  return sortByName(groups)
})

export const selectOpenGroupIds = createSelector(
  selectBase,
  base => base.openGroupIds
)

export function selectGroupIdFromProps(_, props) {
  return props.groupId || null
}

export function makeSelectGroupById() {
  return createSelector(
    selectGroupIdFromProps,
    selectGroupsById,
    selectFolders,
    (groupId, groupsById, folders) => {
      const group = groupsById[groupId]
      if (!group) return emptyObj
      const groupFolderIds = sortByKey(
        folders.filter(folder => folder.groupId === groupId),
        'position'
      ).map(folder => folder.id)
      return { ...groupsById[groupId], folderIds: groupFolderIds }
    }
  )
}
